module.exports = __webpack_public_path__ + "cace60c291d2467722ec2bcd750ae601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic7.png
// module id = 1866
// module chunks = 0